import { BRAND } from "./constants";

export const SEASONS = {
  rakhi: {
    name: "Rakhi",
    eyebrow: "The Rakhi Edit · 28 August 2026",
    line1: "For the sibling who",
    line2: "deserves more than a text.",
    subcopy:
      "Rakhi hampers and sibling gifting — artisanal rakhis, festive sweets and keepsakes, sent to one doorstep or to every employee's home across India.",
    cta: "Book your Rakhi brief",
    occasion: "Festive Gifting",
    message: "I'm interested in the Rakhi Edit — company-wide and personal gifting. ",
    heroImage: BRAND.wedding,
    picks: ["gourmet-confectionery", "tea-coffee", "signature-collections", "lifestyle-welcome"],
    timeline: [
      { date: "By 20 Jul", title: "Brief", text: "Recipient list, home addresses and budget band locked." },
      { date: "By 5 Aug", title: "Sampling", text: "Approve the rakhi, the sweets and the note card design." },
      { date: "Mid Aug", title: "Production", text: "Hand-tied rakhis, wrapped and sealed in our studio." },
      { date: "By 24 Aug", title: "Delivery", text: "Timed to arrive before Raksha Bandhan, pan-India." },
    ],
    notes: [
      "Artisanal rakhis hand-tied by karigars — no plastic, no bulk-import look.",
      "A personal note in every box, printed or handwritten at scale.",
      "Address collection handled for you — one spreadsheet is all we need.",
    ],
  },
  "new-year": {
    name: "New Year",
    eyebrow: "The New Year Edit · 2027",
    line1: "Start their year",
    line2: "with your name on it.",
    subcopy:
      "New Year hampers, desk calendars and appreciation boxes for clients and teams — booked early, delivered in the final week of December.",
    cta: "Book your New Year brief",
    occasion: "Festive Gifting",
    message: "I'm interested in the New Year Edit for client and team gifting. ",
    heroImage: "https://images.unsplash.com/photo-1668127039849-c5dd95be3fa5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
    picks: ["desk-stationery", "drinkware", "signature-collections", "gourmet-confectionery"],
    timeline: [
      { date: "By 15 Oct", title: "Brief", text: "Audience, quantities and branding directions confirmed." },
      { date: "By 10 Nov", title: "Sampling", text: "Physical sample with your 2027 calendar and branding." },
      { date: "Nov – Dec", title: "Production", text: "Assembly and quality checks through early December." },
      { date: "22 – 29 Dec", title: "Delivery", text: "Land on desks in the last week of the year." },
    ],
    notes: [
      "Letterpress 2027 desk calendars with your brand on every month.",
      "Year-end appreciation messaging, written with you.",
      "December courier capacity is reserved in advance — slots are finite.",
    ],
  },
};

export const SEASON_LINKS = [
  { slug: "rakhi", label: "Rakhi", to: "/season/rakhi" },
  { slug: "diwali", label: "Diwali", to: "/festive" },
  { slug: "new-year", label: "New Year", to: "/season/new-year" },
];
